import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useMsal } from '@/composition-api/useMsal';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignOutButton',
  setup(__props) {

const { instance } = useMsal();

const logoutPopup = () => {
 
  instance.logoutPopup({
    
    mainWindowRedirectUri: "/",
  }).then(() => {
     sessionStorage.removeItem('user');
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    color: "primary",
    class: "md6 mr-2 dropdown_text",
    size: "small",
    onClick: logoutPopup
  }, "Signout"))
}
}

})